export const DEFAULT_AVATAR = 'https://storage.googleapis.com/assets-us-east4-propilatam-dev/avatars/default-avatar.png'